import { $, Swiper } from "../shared/globals.js";

export function createGallerySwiperFeature() {
    const instances = [];

    function handlePointerDown() {
        $(this).addClass("is-gallery-pointer-down");
    }

    function handlePointerUp() {
        $(".gallery-wrapper.gallery-swiper").removeClass("is-gallery-pointer-down");
    }

    function prepareGallery($gallery) {
        if ($gallery.data("gallerySwiperPrepared")) {
            return $gallery.children(".swiper-wrapper");
        }

        const $originalSlides = $gallery.children(".gallery-image-item");
        if (!$originalSlides.length) {
            return null;
        }

        const $wrapper = $('<div class="swiper-wrapper"></div>');
        $originalSlides.each(function() {
            $(this).addClass("swiper-slide");
            $wrapper.append(this);
        });

        $gallery.addClass("swiper gallery-swiper");
        $gallery.append($wrapper);

        const $preparedSlides = $wrapper.children(".gallery-image-item");
        $preparedSlides.each(function() {
            const $clone = $(this).clone(true, true);
            $clone.addClass("is-gallery-duplicate");
            $wrapper.append($clone);
        });

        $gallery.data("gallerySwiperPrepared", true);

        return $wrapper;
    }

    function init() {
        if (!Swiper) return;

        $(".gallery-wrapper").each(function(index) {
            const $gallery = $(this);
            if ($gallery.data("gallerySwiperInstance")) {
                return;
            }

            const $wrapper = prepareGallery($gallery);
            if (!$wrapper || !$wrapper.children(".swiper-slide").length) {
                return;
            }

            const swiper = new Swiper(this, {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 32,
                speed: 700,
                rewind: true,
                loop: false,
                allowTouchMove: true,
                grabCursor: false,
                watchOverflow: false,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.2,
                        spaceBetween: 16,
                    },
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    767: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                    991: {
                        slidesPerView: 4,
                        spaceBetween: 32,
                    },
                },
            });

            $gallery.on("pointerdown.gallery-paw mousedown.gallery-paw", handlePointerDown);
            $gallery.attr("data-gallery-swiper-index", index);
            $gallery.data("gallerySwiperInstance", swiper);
            instances.push(swiper);
        });

        $(document).off("pointerup.gallery-paw pointercancel.gallery-paw mouseup.gallery-paw");
        $(document).on("pointerup.gallery-paw pointercancel.gallery-paw mouseup.gallery-paw", handlePointerUp);
    }

    function destroy() {
        instances.forEach((instance) => {
            instance.destroy(true, true);
        });

        instances.length = 0;

        $(".gallery-wrapper")
            .removeData("gallerySwiperInstance")
            .removeClass("is-gallery-pointer-down")
            .off(".gallery-paw");
        $(document).off("pointerup.gallery-paw pointercancel.gallery-paw mouseup.gallery-paw");
    }

    return {
        init,
        destroy,
    };
}
